import { apiClient as api } from './api';
import { callV3, type ApiResponse } from '../api/envelope';

/**
 * The signed-in user's directory profile.
 *
 * `available` is false when the directory isn't configured or couldn't be reached. That is
 * not an error to show: the token already carries a name and email, so the page falls back
 * to those rather than telling the user something broke that they cannot fix.
 */
export interface UserProfile {
  available: boolean;
  email: string | null;
  firstName: string | null;
  lastName: string | null;
  middleName: string | null;
  phoneNumber: string | null;
  photoUrl: string | null;
}

/**
 * Profile reads. Served by our API, which proxies the central directory — the browser can't
 * call it directly, because its CORS allowlist covers the SSO origin and not ours.
 *
 * Read-only by design. Identity lives in the central app; giving Coral its own edit surface
 * would mean two places a name can disagree, and the central API exposes no update route.
 */
export const ProfileService = {
  getProfile: () => callV3<UserProfile>(api.get<ApiResponse<UserProfile>>('/api/v3/me/profile')),
};
